// extracted by mini-css-extract-plugin
export default {"container":"SSScreen_container__iyxcR","content":"SSScreen_content__lEIqH","contentNoPadding":"SSScreen_contentNoPadding__3uUvE"};